<template>
    <div ref="sidewindow" :key="forceUpdate" class="md:ml-4 w-full md:max-w-[40vw]  max-w-[700px]"
        :class="iframe ? 'md:!w-[300px]' : ''">
        <div
            class="w-full min-h-[95vh] z-[6] p-3 md:z-[4] md:min-h-[75vh] md:h-full rounded-3xl bg-white dark:bg-neutral-900/20 dark:backdrop-blur-xl ring-1 !ring-black/10 dark:!ring-neutral-300/10 dark:text-white">
            <div v-if="!promotions.length && !locations.length"
                class="grid min-h-[140px] w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
                <svg class="text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24">
                    <path
                        d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path
                        d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"
                        class="text-gray-900">
                    </path>
                </svg>
            </div>
            <div v-else>
                <div v-if="promotions.length" class="grid grid-cols-2 gap-4">
                    <div v-for="(item, index) in promotions" @click="handleFeatureClick(item.resource.slug, item.resource_type == 'App\\Models\\Property')"
                        class="snap-start transition relative cursor-pointer group dark:text-white hover:bg-gray-200 active:scale-90 dark:hover:bg-neutral-800 md:p-2 rounded-xl w-full">
                        <div
                            class="bg-white dark:bg-neutral-900 rounded-lg mb-2 w-full flex justify-center items-center shadow-lg group-hover:shadow-none group-hover:scale-95 transition relative aspect-square">
                            <a v-if="item.show_promoted_icon" @click.stop :href="$baseUrl + '/termsandconditions#sponsored'"
                                target="blank"
                                class="bg-black/50 backdrop-blur-sm p-2 rounded-full absolute left-2 top-2 text-gray-200 hover:text-yellow-400 z-5 transition-all duration-500 flex items-center justify-start group/promotion max-w-[32px] hover:max-w-full overflow-hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512"
                                    class="w-4 h-4 shrink-0">
                                    <path
                                        d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z">
                                    </path>
                                </svg>
                            </a>

                            <img v-if="item.image_link || item.resource.image_link"
                                class="w-full h-full object-cover rounded-lg pointer-events-none"
                                :src="item.image_link ?? item.resource.image_link" alt="Event image" loading="lazy" />
                            <div v-else class="bg-gray-300 dark:bg-neutral-600 w-full h-full rounded-lg">
                            </div>
                        </div>

                        <div class="w-full overflow-hidden relative h-4 xs:h-5 sm:h-6">
                            <span class="scroll_long_text capitalize text-xs xs:text-sm sm:text-base" :class="iframe ? '!text-sm' : ''">
                                {{ getTranslated(item.resource.name) }}
                            </span>
                        </div>

                        <div class="w-full overflow-hidden relative h-4 md:h-5">
                            <span v-if="item.resource_type == 'App\\Models\\Location'" class="scroll_long_text text-xs text-gray-700 dark:text-neutral-400">
                                {{ item.resource.street }},
                                {{ item.resource.postcode }} {{ item.resource.city }}
                            </span>
                            <span v-else-if="item.resource_type == 'App\\Models\\Property'" class="scroll_long_text text-xs text-gray-700 dark:text-neutral-400">
                                {{ item.resource.propertyType }}
                            </span>
                        </div>
                    </div>

                    <div class="mb-4 p-4 flex justify-center items-center bg-gradient-to-br from-primary/5 to-purple-100 dark:from-neutral-700/50 dark:to-neutral-800/50 rounded-lg border border-gray-200 dark:border-neutral-700 shadow-sm gap-4 flex-col sm:flex-row md:flex-col"
                        :class="[
                            'p-4 rounded',
                            (promotions.length % 2 === 0) ? 'col-span-2 aspect-video' : 'aspect-square'
                        ]">

                        <div class="flex flex-col gap-4 items-center"  :class="iframe ? '!gap-2' : ''">
                            <!-- Icon -->
                            <div
                                class="flex items-center justify-center w-12 h-12 bg-primary_opc_less rounded-full flex-shrink-0"  :class="iframe ? '!w-8 !h-8' : ''">
                                <svg-vue icon="crown" class="w-6 h-6 text-primary"  :class="iframe ? '!w-4 !h-4' : ''"></svg-vue>
                            </div>

                            <!-- Content -->
                            <div class="flex-1">
                                <h3 class="text-lg font-semibold text-gray-800 dark:text-white text-center"  :class="iframe ? '!text-base' : ''">
                                    {{ $t('Boost your visibility') }}
                                </h3>
                            </div>
                        </div>

                        <!-- CTA -->
                        <div class="shrink-0">
                            <a :href="$baseUrl + '/dashboard'"
                                class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-gradient shadow-xl rounded-xl shadow hover:bg-primary/90 transition text-center">
                                {{ $t('Promote your location') }}
                            </a>
                        </div>

                    </div>
                </div>
                <div class="grid grid-cols-2 gap-4 mb-4">
                    <div v-for="(item, index) in randomLocations"  @click="handleFeatureClick(item.slug)"
                        class="snap-start transition relative cursor-pointer group dark:text-white hover:bg-gray-200 active:scale-90 dark:hover:bg-neutral-800 md:p-2 rounded-xl w-full">
                        <div
                            class="bg-white dark:bg-neutral-900 rounded-lg mb-2 w-full flex justify-center items-center shadow-lg group-hover:shadow-none group-hover:scale-95 transition relative aspect-square">
                            <img v-if="item.image_link || item.image_link"
                                class="w-full h-full object-cover rounded-lg pointer-events-none"
                                :src="item.image_link ?? item.image_link" alt="Event image" loading="lazy" />
                            <div v-else class="bg-gray-300 dark:bg-neutral-600 w-full h-full rounded-lg">
                            </div>
                        </div>

                        <div class="w-full overflow-hidden relative h-4 xs:h-5 sm:h-6">
                            <span class="scroll_long_text capitalize text-xs xs:text-sm sm:text-base" :class="iframe ? '!text-sm' : ''">
                                {{ getTranslated(item.name) }}
                            </span>
                        </div>

                        <div class="w-full overflow-hidden relative h-4 md:h-5">
                            <span class="scroll_long_text text-xs text-gray-700 dark:text-neutral-400">
                                {{ item.street }},
                                {{ item.postcode }} {{ item.city }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useTypeMeta } from '../../helpers/useTypeMeta'
const { debounce } = require('lodash');

export default {
    name: 'mapOverview',

    props: {
        iframe: {
            type: Boolean,
            default: false,
        },
        promotions: {
            type: Array,
            default: () => [],
        },
        locations: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {
            map: null,
            selectedLocation: null,
            randomLocations: [],
            forceUpdate: 0,
            filters: {
                search: '',
                date: '',
                location_id: '',
            },
        };
    },
    mounted() {
        this.shuffleLocations();
    },
    computed: {
        selectedLocationData() {
            return this.locations.find(loc => loc.id == this.selectedLocation);
        }
    },
    methods: {
        meta(type) {
            return useTypeMeta(type)
        },
        getTranslated(item, lang = 'en') {
            if (!item) return '';

            const translations = item[lang] || item['en'] || item;
            return translations;
        },
        shuffleLocations() {
            this.randomLocations = [...this.locations]
                .sort(() => Math.random() - 0.5)
                .slice(0, 20);
        },
        handleFeatureClick(slug, isProperty=false) {
            if (isProperty) {
                this.$router.push({
                    name: 'locations.map.showProp',
                    params: { slug: slug },
                    query: { ...this.$route.query }
                });
            } else {
                this.$router.push({
                    name: 'locations.map.show',
                    params: { slug: slug },
                    query: { ...this.$route.query }
                });
            }
            

            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    watch: {
        selectedLocation(newVal) {
            if (newVal === null) this.shuffleLocations();
        },
        locations(newVal) {
            if (newVal?.length) this.shuffleLocations();
        },
    },
};
</script>